import challenge from './challenge';
import judging from './judging';
import matches from './matches';

export default {
  challenge,
  judging,
  matches
}